import { render, staticRenderFns } from "./TarifItem.vue?vue&type=template&id=7fac87d0&"
import script from "./TarifItem.vue?vue&type=script&lang=js&"
export * from "./TarifItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports